import { withTheme, SvyCheckbox as Checkbox } from '@innovorder/savory';
import { withIntlLabel } from '@/locales/withIntlLabel';
import styled from '@emotion/styled';

const SvyCheckboxTmp = withIntlLabel(withTheme(Checkbox));

export const SvyCheckbox = styled(SvyCheckboxTmp, {
    shouldForwardProp: (prop) => !['isTouched', 'isDirty'].includes(prop),
})``;
